import React from 'react';
import { KfsInputs, KfsCalculatedValues, KFS_CONSTANTS } from '../types/kfs.types';
import { formatINR, formatAPR } from '../utils/kfsFormulas';
import { formatDate } from 'utils/lmmsHelpers';

interface KfsPrintLayoutProps {
  inputs: KfsInputs;
  values: KfsCalculatedValues | null;
}

const INSTALMENT_LABELS = ['Q1', 'Q2', 'Q3', 'Q4'];

const KfsPrintLayout: React.FC<KfsPrintLayoutProps> = ({ inputs, values }) => {
  if (!values) return null;

  return (
    <div className="kfs-print-layout">
      <div className="kfs-print-inner">
      <div className="kfs-print-header">
        <h1>VALLUVANAD MONEY</h1>
        <h2>Gold Loan — Key Fact Statement</h2>
      </div>

      <div className="kfs-print-divider" />

      <div className="kfs-print-section">
        <table className="kfs-print-table">
          <tbody>
            <tr>
              <td className="kfs-print-label">Loan Amount</td>
              <td className="kfs-print-value">{inputs.loanAmount != null ? formatINR(inputs.loanAmount) : '--'}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Loan Date</td>
              <td className="kfs-print-value">{formatDate(inputs.loanDate)}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Interest Rate</td>
              <td className="kfs-print-value">{inputs.interestRate != null ? inputs.interestRate.toFixed(3) + '%' : '--'}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Gross Weight</td>
              <td className="kfs-print-value">{inputs.grossWeight != null ? inputs.grossWeight + ' g' : '--'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="kfs-print-divider" />

      <div className="kfs-print-section">
        <table className="kfs-print-table">
          <tbody>
            <tr>
              <td className="kfs-print-label">Insurance Charge</td>
              <td className="kfs-print-value">{formatINR(values.insuranceCharge)}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">APR</td>
              <td className="kfs-print-value">{formatAPR(values.apr)}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Total Interest</td>
              <td className="kfs-print-value">{formatINR(values.totalInterest)}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Fee Charges</td>
              <td className="kfs-print-value">{formatINR(values.feeCharges)}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Payable to RE</td>
              <td className="kfs-print-value">{formatINR(values.payableToRE)}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Net Disbursement</td>
              <td className="kfs-print-value">{formatINR(values.netDisbursement)}</td>
            </tr>
            <tr>
              <td className="kfs-print-label">Total Payable</td>
              <td className="kfs-print-value">{formatINR(values.totalAmountPayable)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="kfs-print-divider" />

      <div className="kfs-print-section">
        <h3 className="kfs-print-subtitle">Instalment Due Dates</h3>
        <table className="kfs-print-table">
          <tbody>
            {INSTALMENT_LABELS.map((label, idx) => (
              <tr key={label}>
                <td className="kfs-print-label">{label} (Loan Date + {KFS_CONSTANTS.INSTALMENT_INTERVALS[idx]} days)</td>
                <td className="kfs-print-value">{formatDate(values.instalmentDueDates[idx])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="kfs-print-divider" />

      <div className="kfs-print-footer">
        Generated on: {formatDate(new Date())}
      </div>
      </div>
    </div>
  );
};

export default KfsPrintLayout;
